/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PostAccountSettingsEmailV2Request
 */
export interface PostAccountSettingsEmailV2Request {
    /**
     * メールアドレス
     * @type {string}
     * @memberof PostAccountSettingsEmailV2Request
     */
    email: string;
    /**
     * パスワード
     * @type {string}
     * @memberof PostAccountSettingsEmailV2Request
     */
    password: string;
}

export function PostAccountSettingsEmailV2RequestFromJSON(json: any): PostAccountSettingsEmailV2Request {
    return PostAccountSettingsEmailV2RequestFromJSONTyped(json, false);
}

export function PostAccountSettingsEmailV2RequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostAccountSettingsEmailV2Request {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': json['email'],
        'password': json['password'],
    };
}

export function PostAccountSettingsEmailV2RequestToJSON(value?: PostAccountSettingsEmailV2Request | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
        'password': value.password,
    };
}

